import { render, staticRenderFns } from "./MajorFirst.vue?vue&type=template&id=717e279c&scoped=true&"
import script from "./MajorFirst.vue?vue&type=script&lang=js&"
export * from "./MajorFirst.vue?vue&type=script&lang=js&"
import style0 from "./MajorFirst.vue?vue&type=style&index=0&id=717e279c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717e279c",
  null
  
)

export default component.exports